export default {

  data: () => ({
    scenario: [

      // 'introduction', 'introduction:1', 'pan', 'instructions',
      // '0', '1', '2', 'explore:1',
      // '3', 'defi2:1', '4', '5', '6', '7', '8', 'explore:2',
      // '9', 'emotions:1', '10', '11', '12', 'explore:3',
      // '13', 'writing:2', '4:bis', '14', '15', 'emotions:2', 'secret', '16', '17', '18', 'tunnel:1', '19', 'machine',
      // '20', '21', '22', '23', '24', '25', 'galerie', '26', 'explore:4', 
      // 'twinning', '27', 'tunnel:2', 
      // '27,1', '28', 
      // '28,1', 
      // 'merci',
      // '29', '30',

      'introduction', 'introduction:1', 'pan', 'instructions',
      '0', '1', '2', '2:bis', 
      'explore:1',
      '3', 
      'defi1:1',
      '5', 
      'explore:2', 'defi1:2', 
      '6', 'use-tunnel',
      'secret', 
      '8', 
      'tunnel:1', 
      '9',
      'codec',
      '10', '11', '12', '13', '13:1', '14',
      'grenier:2',
      '15',      
      'defi2:1', '16', '17', '19','18',    

      'tunnel:2',      
      
      'explore:3',
      'defi2:2',
      '20', '21', '22',
      'explore:4',
      'defi2:3',
      '23',
      '24',
      '25',
      '26',
      '27',
      // '28',
      // '29',
      '30',
      '31',
      '32',
      'defi3',
      '33',
      'merci',
      '35',
      'monde', 'monde:1', 'monde:2'
    ],
  }),


  computed: {
    match() { return this.$store.getters['app/match'] },
    oeuvres() { return this.$store.getters['app/oeuvres'] },
    archives() { return this.$store.getters['app/archives'] },
    is2DWorld() {
      return !this.is3DWorld
    },
    is3DWorld() {
      if(this.$route.meta.name == 'artwork' && !this.$route.params.id)
        return true

      if(this.$route.params.page)
        return true

      // if(this.slugIsIn([
      //   'pan', 'explore:1', 'explore:2', 'explore:3', 'secret', 'tunnel:1', 'machine',
      //   'galerie', 'explore:4', 'tunnel:2'
      // ]))

      if(this.slugIsIn([
        'pan', 'explore:1', 'explore:2', 'secret', 'tunnel:1', 'codec', 'grenier:2', 
        'tunnel:2','explore:3', 'explore:4'
      ]))
        return true

      return false
    },
    isVoice() {
			return this.trans('Global.voice.'+ this.$route.params.slug) != ' '
    },
    oeuvre() {
      const oeuvres = this.$store.getters['app/oeuvres']
      let oeuvre = _.find(oeuvres, o => o.is_active)
      if(!oeuvre) {
        let extracts = []
        _.each(oeuvres, (o)=>{
          if(_.indexOf([
            'o_ADAD_HANNAH',
            'o_HUA_JIN',
            'o_JJ_LEVINE',
            'o_MARISA_PORTOLESE',
            'o_MARISA_PORTOLESE_02',
            'o_MORIDJA_KITENGE_BANZA',
            'o_MORIDJA_KITENGE_BANZA_02'
          ], o.name) != -1) {
            extracts.push(o)
          }
        })
        oeuvre = _.sample(extracts)
      }

      // debug get only archived
      // const oeuvres_archive_only = _.map(this.archives, a => _.find(this.oeuvres, o => o.archive == a.id) )
      // oeuvre = _.find(oeuvres_archive_only, o => this.match.indexOf(o.archive) === -1)
      // end debug

      return oeuvre
    },
    scenarioIndex() {
      if(this.$route.meta.name != 'museum') return false
      return this.scenario.indexOf(this.$route.params.slug)
    }
  },
  methods: {
    return3DWorld() {
      if(this.$root.$agent.mobile) return
      this.$store.commit('app/SET_AMBIANCE', 'selection')
      const canvas = document.querySelector('.World canvas')

      if(canvas) {
        canvas.requestPointerLock()
        canvas.focus()
      }
    },
    next() {

      // this.$store.commit('app/CALL_NEXT')

      if(this.$route.meta.name != 'museum')
        return false

      if(this.slugIsIn(['defi1:1', 'defi1:2', 'defi2:1', 'defi2:2', 'defi2:3', 'defi3'])) {
        // this.$store.commit('app/SET_AMBIANCE', 'recompense')
        this.$store.commit('app/SET_AMBIANCE', 'selection')
        TweenMax.delayedCall(.25, ()=> this.$store.commit('app/SET_AMBIANCE', 'recompense'))
      } 
      else if(this.slugIsIn(['16', '20', '23'])) {
        this.$store.commit('app/SET_AMBIANCE', 'selection')
        TweenMax.delayedCall(.25, ()=> this.$store.commit('app/SET_AMBIANCE', 'succes'))
      }
      else if(this.slugIsIn(['codec'])) {
        this.$store.commit('app/SET_AMBIANCE', 'find_codex')
      }
      else if(this.slugIsIn(['use-tunnel'])) {
        TweenMax.delayedCall(1.5, ()=> this.$store.commit('app/SET_AMBIANCE', 'open'))
      }
      else if(this.slugIsIn(['35'])) {
        TweenMax.delayedCall(.25, ()=> this.$store.commit('app/SET_AMBIANCE', 'spirits'))
      }
      else if(this.slugIsIn(['instructions', 'introduction', 'introduction:1', 'monde', 'monde:1', 'monde:2'])) {
        this.$store.commit('app/SET_AMBIANCE', 'selection')
      }

      const nextSlug = this.scenario[this.scenarioIndex + 1]

      if(!nextSlug) {
        this.return3DWorld()
        return this.$router.push({ name: 'artwork.' + this.lang })
      }

      // if(['explore:1', 'explore:2', 'explore:3', 'tunnel:1', 'machine', 'galerie', 'explore:4', 'tunnel:2'].indexOf(nextSlug) > -1)
      if(['explore:1', 'explore:2', 'explore:3', 'tunnel:1', 'codec', 'grenier:2', 'explore:4', 'tunnel:2'].indexOf(nextSlug) > -1)
        this.return3DWorld()

      if(this.slugIsIn(['defi1:1', 'defi1:2', 'defi2:1', 'defi2:2', 'defi2:3', 'defi3']))
        TweenMax.delayedCall(.25, ()=> this.$router.push({ name: 'museum.' + this.lang, params: { slug: nextSlug } })) 
      else
         this.$router.push({ name: 'museum.' + this.lang, params: { slug: nextSlug } }) 
    },
    slugIsIn(array) {
      if(this.$route.meta.name != 'museum') return false
      return array.indexOf(this.$route.params.slug) > -1
    },
    slugIsBefore(slug) {
      if(this.$route.meta.name != 'museum') return false
      return this.scenarioIndex < this.scenario.indexOf(slug)
    },
    slugIsAfter(slug) {
      if(this.$route.meta.name != 'museum') return false
      return  this.scenarioIndex > this.scenario.indexOf(slug)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Commons.js